import { Button, Select } from "antd";
import { size } from "lodash";
import { useEffect, useState } from "react";
import Layout, { Breadcrumb, Container } from "../../components/layout";
import { useAppState } from "../../context";

const { Option } = Select;

const CurrentWeekSetting = () => {
  const { getAllWeeks, allWeeks, updateWeekSetting, currentWeekData } =
    useAppState("weekSetting");

  const [selectWeekData, setSelectWeekData] = useState<Array<any>>([]);
  const [selectedWeekId, setSelectedWeekId] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);
  // Fetch initial data once
  const { userData } = useAppState("auth");
  //------UPLOAD SECTION-----START------
  //const [fileList, setFileList] = useState<any[]>([]);
  //const isUploadVisible = fileList.length === 0;
  /* const handleSubmit = async () => {
    if (fileList.length === 0) return;

    const formData = new FormData();

    console.log("fileList[0].originFileObj >>>", fileList[0].originFileObj);

    ///return;
    formData.append("file", fileList[0].originFileObj);

    try {
      const response = await fetch("/api/upload", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      console.log("Response: ", data);
    } catch (error) {
      console.error(error);
    }
  }; */

  /* const handleFileChange = ({ fileList }: any) => {
    setFileList(fileList.slice(-1)); // Allow only one file
  };

  const handleRemove = () => {
    setFileList([]);
  }; */
  //------UPLOAD SECTION-----END--------

  useEffect(() => {
    if (!allWeeks.length) {
      getAllWeeks();
    }
  }, []);

  useEffect(() => {
    if (allWeeks.length) {
      const filterData = allWeeks.map((item: any, index: any) => {
        return { ...item, id: parseInt(index), name: item.week };
      });

      const idsToRemove = userData.ignoreWeek;
      const weekFilterId = filterData.filter((item: any) => {
        return !idsToRemove.includes(item._id);
      });

      console.log("filterData >>>", filterData);
      console.log("currentWeekData >>>", currentWeekData);

      setSelectWeekData(weekFilterId);
      setSelectedWeekId(currentWeekData?._id || ""); // Set the first week as default selection
    }
  }, [allWeeks]);

  // Handle dropdown selection change
  const handleSelectChange = (value: string) => {
    setSelectedWeekId(value);
  };

  // Handle submit
  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("week", selectedWeekId);
      /* formData.append(
        "file",
        fileList.length === 0 ? "" : fileList[0].originFileObj,
      ); */
      /* console.log("fileList Length >>>", fileList.length);
      console.log("fileList >>>", fileList[0].originFileObj);
      console.log("selectedWeekId >>>", selectedWeekId);
      */
      const success = await updateWeekSetting(formData);

      if (success) {
        await getAllWeeks(); // Refresh the data only on successful update
      }

      setIsLoading(false);
    } catch (error) {
      console.error("Failed to update week setting:", error);
      setIsLoading(false);
    }
  };

  return (
    <Layout>
      <Breadcrumb title="Current Week Setting" />
      <Container>
        {/* Dropdown for member selection */}
        <div className="mb-4">
          <Select
            // mode="multiple"
            disabled={isLoading}
            style={{ width: "100%" }}
            placeholder="Select Current Week"
            value={selectedWeekId}
            onChange={handleSelectChange}
            // maxTagCount={4}
            optionFilterProp="children"
          >
            {selectWeekData.map((weekDetail: any) => (
              <Option key={weekDetail._id} value={weekDetail._id}>
                {weekDetail.week}
              </Option>
            ))}
          </Select>
        </div>

        {/* <div>
          <div className="mb-6">
            <Upload
              fileList={fileList}
              onChange={handleFileChange}
              beforeUpload={() => false}
              showUploadList={false}
              multiple={false}
              accept=".csv"
              disabled={
                !isUploadVisible || size(selectedWeekId) === 0 || isLoading
              }
            >
              <button
                type="button"
                disabled={
                  !isUploadVisible || size(selectedWeekId) === 0 || isLoading
                }
                className={`bg-[#00A48B] text-white font-bold py-2 px-5 rounded-full flex items-center gap-3
                ${
                  !isUploadVisible || size(selectedWeekId) === 0 || isLoading
                    ? "opacity-50 cursor-not-allowed"
                    : "cursor-pointer"
                }`}
              >
                <img
                  src={allImgPaths.Upload_Icon}
                  className="w-6 h-6"
                  alt="Upload"
                />

                <span>Upload .CSV File</span>
              </button>
            </Upload>
            {fileList.length > 0 && (
              <div className="mt-4 flex items-center justify-between border rounded-lg px-4 py-3 bg-gray-50">
                <div className="flex items-center gap-3">
                  <img
                    src={allImgPaths.Upload_Icon}
                    className="w-5 h-5"
                    alt=""
                  />

                  <span className="font-medium">{fileList[0].name}</span>
                </div>

                <Button
                  danger
                  type="text"
                  icon={<DeleteOutlined />}
                  onClick={handleRemove}
                >
                  Delete
                </Button>
              </div>
            )}
          </div>
        </div> */}

        {/* Submit button */}
        <Button
          type="primary"
          onClick={handleSubmit}
          disabled={size(selectedWeekId) === 0 || isLoading}
          className="mb-6"
        >
          Submit
        </Button>
        {isLoading && <h1 className="text-center">Loading...</h1>}
      </Container>
    </Layout>
  );
};

export default CurrentWeekSetting;
